import React from 'react';
import { InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { SearchContainer, StyledTextField } from '../StyledComponents';
import { SearchSectionProps } from '../types';

const SearchSection: React.FC<SearchSectionProps> = ({
  searchQuery,
  onSearchChange,
  onSearchSubmit,
  loading
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && searchQuery.trim() && !loading) {
      onSearchSubmit(searchQuery.trim());
    }
  };

  return (
    <SearchContainer>
      <StyledTextField
        fullWidth
        placeholder="What email do you want to generate today?"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        onKeyPress={handleKeyPress}
        // InputProps={{
        //   startAdornment: (
        //     <InputAdornment position="start">
        //       <SearchIcon sx={{ color: '#94a3b8', fontSize: 24 }} />
        //     </InputAdornment>
        //   ),
        // }}
      />
    </SearchContainer>
  );
};

export default SearchSection;
